import naja from 'naja';

export default function initializePoller(container: HTMLElement): void {
    container.querySelectorAll(`.poller`)
        .forEach(element => {
            const url = element.getAttribute('data-url');
            const period = element.getAttribute('data-period');

            if (url === null || period === null) {
                return;
            }

            const timer = setInterval(() => {
                if (document.body.contains(element)) {
                    naja.makeRequest('GET', url, null, {history: false});
                }

                clearInterval(timer);
            }, +period);

            const modal = element.closest('.modal');

            if (modal === null) {
                return;
            }

            modal.addEventListener('hidden.bs.modal', () => {
                clearInterval(timer);
            });
        });
}
